<template>
  <div class="container">
    <panel
      Title=" وضعیت کاربران "
      Des="از طریق این منو میتوانید وضعیت ورود کاربران به اینترنت بانک را مشاهده کنید و وضعیت آنها را تغییر دهید.."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>

    <div class="row">
      <div class="col-2"></div>
      <div class="col-md-8 col-12">
        <net-pa-card>
          <template v-slot:header>
            <h6><i class="fas fa-users"></i> وضعیت کاربران</h6>
          </template>
          <template v-slot:content>
            <div class="container">
              <div class="row mb-5">
                <div class="col-md-1 m-1">
                  <label for="CodeMeli">کدملی کاربر</label>
                </div>
                <div class="col-md-3 col-12 my-1 m-1">
                  <form id="searchAza">
                    <input
                      type="text"
                      @keypress="$ValidNumber($event, 14)"
                      id="CodeMeli"
                      class="form-control text-left required-CodeMeli"
                      v-model="CodeMeli"
                      autocomplete="off"
                    />
                  </form>
                </div>
                <div class="col-md-4 col-12 m-1">
                  <CaptchaBox
                    ref="captchaRef"
                    @update="onCaptchaValid"
                  ></CaptchaBox>
                </div>
                <div class="col-md-3 col-12 m-1">
                  <button
                    :disabled="!CaptchaValid"
                    class="btn rounded btn-success w-100"
                    @click="SearchByCodeMeli"
                  >
                    جستوجوی مشتری
                  </button>
                </div>
              </div>
              <div
                v-if="searchedUSer != null"
                class="row mt-5 px-3 pulse"
                id="animate"
              >
                <div class="col-md-6 col-12 my-1">
                  <div class="row">
                    <div class="col-4">
                      <small>مشخصات کاربر</small>
                    </div>
                    <div class="col-8 text-right">
                      {{ Moshakhasat }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 my-1">
                  <div class="row">
                    <div class="col-4">
                      <small>شماره مشتری </small>
                    </div>
                    <div class="col-8 text-right">
                      {{ ShomareOzv }}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-12 my-1">
                  <div class="row">
                    <div class="col-4">
                      <small>تاریخ اخرین ورود</small>
                    </div>
                    <div class="col-8 text-right">
                      {{ TarixlastEnter }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 my-1">
                  <div class="row">
                    <div class="col-4">
                      <small> دفعات ورود ناموفق</small>
                    </div>
                    <div class="col-8 text-right text-danger">
                      {{ CountAuthFailed }}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-12 my-1">
                  <div class="row">
                    <div class="col-4">
                      <small> وضعیت کاربر</small>
                    </div>
                    <div class="col-8 text-right">
                      <span v-if="VaziatKarbar" class="text-danger">
                        غیرفعال <i class="fas fa-times"></i
                      ></span>
                      <span v-else class="text-success">
                        فعال <i class="text-success fas fa-check"></i
                      ></span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-12"></div>
                <div class="col-8 mx-2"></div>
                <div class="col-12 col-md-4 mt-3">
                  <button
                    v-if="VaziatKarbar"
                    :disabled="CodeMeli == ''"
                    class="w-100 btn btn-info"
                    @click="changevaziat()"
                  >
                    فعال کردن کاربر
                  </button>
                  <button
                    v-else
                    :disabled="CodeMeli == ''"
                    class="w-100 rounded btn btn-danger"
                    @click="changevaziat()"
                  >
                    غیرفعال کردن کاربر
                  </button>
                </div>
                <div class="col-1"></div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";
export default {
  data() {
    return {
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      CodeMeli: "",
      Moshakhasat: "",
      ShomareOzv: "",
      TarixlastEnter: "",
      CountAuthFailed: "",
      VaziatKarbar: "",
      searchedUSer: null,
    };
  },
  components: { NetPaCard, Panel, CaptchaBox },

  methods: {
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    SearchByCodeMeli() {
      if (this.$requiredCodeMeli("searchAza")) {
        var formdata = new FormData();
        formdata.append("Codemeli", this.CodeMeli);
        formdata.append("userInput", this.captchaText);
        formdata.append("captchaId", this.captchaId);
        var DataAxiosGetuser = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "getUserByCodeMeli",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostFormData(DataAxiosGetuser).then((data) => {
          if (data.status == "OK") {
            this.searchedUSer = data.data.id;
            this.$mySweetDefaultTost("عملیات موفق", "", "success", 2000);
            this.Moshakhasat = data.data.ozvName + " " + data.data.ozvFamily;
            this.ShomareOzv = data.data.shomareOzv;
            this.TarixlastEnter = data.data.axarinVorodBeSite;
            this.CountAuthFailed = data.data.countAuthFailed;

            this.VaziatKarbar = data.data.isLockForLogin;
            this.refreshCaptcha();
          } else {
            this.searchedUSer = null;
            this.$mySweetDefaultTost("عملیات ناموفق", data.msg, "error", 2000);
            this.refreshCaptcha();
          }
        });
      }
    },
    changevaziat() {
      var formdata = new FormData();
      // console.log(this.searchedUSer);
      formdata.append("Id", this.searchedUSer);
      formdata.append("countAuth", 0);
      var DataAxiosGetuser = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "AxarinVorod/ChangeVaziat",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosGetuser).then((data) => {
        if (data.status == "OK") {
          this.searchedUSer = data.data.id;
          this.$mySweetDefaultTost("عملیات موفق", "", "success", 2000);
          this.Moshakhasat = data.data.ozvName + " " + data.data.ozvFamily;
          this.ShomareOzv = data.data.shomareOzv;
          this.TarixlastEnter = data.data.axarinVorodBeSite;
          this.CountAuthFailed = data.data.countAuthFailed;
          this.VaziatKarbar = data.data.isLockForLogin;
          this.refreshCaptcha();
        } else {
          this.searchedUSer = null;
          this.$mySweetDefaultTost(
            " خطا",
            "مشکلی در بروز رسانی اطلاعات بوجود آمده است. دوباره تلاش کنید.",
            "error",
            2000,
          );
          this.refreshCaptcha();
        }
      });
    },
  },
};
</script>
<style scoped>
.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>
